import { render, staticRenderFns } from "./ImportInventoryLegacy.vue?vue&type=template&id=c03a43dc"
import script from "./ImportInventoryLegacy.vue?vue&type=script&lang=js"
export * from "./ImportInventoryLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports